<template>
  <div v-if="(evaluations && evaluations.length > 0) || comparisons">
    <h3 v-if="categoryId !== 'UNS'">性能
      <tooltip-icon :content="evaluationTitleTip"></tooltip-icon>
    </h3>
    <h3 v-else>集計</h3>

    <div class="evaluations-container" v-if="evaluations && evaluations.length > 0">
      <el-card v-for="evaluation in evaluations" :key="evaluation.name" shadow="never" class="evaluation-card" :top="0"
               :modal="false">
        <div class="evaluation-card-name">{{evaluation.nameJa}}</div>
        <div class="evaluation-card-level" :class="evaluationLevelCls(evaluation)">{{evaluationLevel(evaluation)}}</div>
        <div class="evaluation-card-value">{{Number(evaluation.value).toFixed(4)}}</div>
        <tooltip-icon class="evaluation-card-tip" v-if="evaluation.description && evaluation.description.text"
                      :content="evaluation.description.text"></tooltip-icon>
      </el-card>
    </div>
    <div class="evaluations-chart-container" v-if="comparisons">
      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-compare"
               @click.native="visibleCompareChartDialog=true" v-if="comparisons.Compare && comparisons.Compare.results">
        <div class="evaluations-chart-name">予測と実績の比較</div>
        <el-carousel v-if="comparisons.Compare && comparisons.Compare.results"
                     indicator-position="none"
                     trigger="click"
                     class="carousel-container"
                     :autoplay="!visibleCompareChartDialog" :interval="5000"
                     :arrow="comparisons.Compare.results.length > 1 ? 'hover' : 'never'"
                     @change="onChangeComparePage">
          <el-carousel-item v-for="(result, index) in comparisons.Compare.results" :key="index"
                            @click.native="visibleCompareChartDialog=true">
            <div class="carousel-label"
                 :style="comparisons.Compare.results.length > 1 ? 'visibility: visible;' : 'visibility: hidden;'">
              {{result.name}}
            </div>
            <compare-chart
                    v-if="Math.abs((index - currentComparePage + 1) % comparisons.Compare.results.length - 1) <= 1"
                    :compareComparison="comparisons.Compare"
                    :yName="yName"
                    :categoryId="categoryId"
                    :initialColumnIndex="index"
                    size="mini"></compare-chart>
          </el-carousel-item>
        </el-carousel>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleCompareChartDialog" custom-class="compare-dialog dialog-size-large" title="予測と実績の比較"
                   :append-to-body="true" :visible="visibleCompareChartDialog" @close="visibleCompareChartDialog=false"
                   top="0" :modal="false">
          <compare-chart :compareComparison="comparisons.Compare" :yName="yName" :categoryId="categoryId"
                         :initialColumnIndex="currentComparePage"></compare-chart>
        </el-dialog>
      </el-card>

      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-lift-compare"
               @click.native="visibleLiftCompareChartDialog=true"
               v-if="comparisons.LiftCompare && comparisons.LiftCompare.results">
        <div class="evaluations-chart-name">リフトチャート</div>
        <el-carousel v-if="comparisons.LiftCompare && comparisons.LiftCompare.results"
                     indicator-position="none"
                     trigger="click"
                     class="carousel-container"
                     :autoplay="!visibleLiftCompareChartDialog" :interval="5000"
                     :arrow="comparisons.LiftCompare.results.length > 1 ? 'hover' : 'never'"
                     @change="onChangeLiftComparePage">
          <el-carousel-item v-for="(result, index) in comparisons.LiftCompare.results" :key="index"
                            @click.native="visibleLiftCompareChartDialog=true">
            <div class="carousel-label"
                 :style="comparisons.LiftCompare.results.length > 1 ? 'visibility: visible;' : 'visibility: hidden;'">
              {{result.name}}
            </div>
            <lift-compare-chart
                    v-if="Math.abs((index - currentLiftComparePage + 1) % comparisons.LiftCompare.results.length - 1) <= 1"
                    :liftCompareComparison="comparisons.LiftCompare"
                    :yName="yName"
                    :categoryId="categoryId"
                    :initialColumnIndex="index"
                    size="mini"></lift-compare-chart>
          </el-carousel-item>
        </el-carousel>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleLiftCompareChartDialog" custom-class="compare-dialog dialog-size-large" title="リフトチャート"
                   :append-to-body="true" :visible="visibleLiftCompareChartDialog"
                   @close="visibleLiftCompareChartDialog=false" top="0" :modal="false">
          <lift-compare-chart :liftCompareComparison="comparisons.LiftCompare" :yName="yName" :categoryId="categoryId"
                              :initialColumnIndex="currentLiftComparePage"></lift-compare-chart>
        </el-dialog>
      </el-card>

      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-cap"
               @click.native="visibleCapChartDialog=true" v-if="comparisons.CAP && comparisons.CAP.results">
        <div class="evaluations-chart-name">CAP曲線</div>
        <el-carousel v-if="comparisons.CAP && comparisons.CAP.results"
                     indicator-position="none"
                     trigger="click"
                     class="carousel-container"
                     :autoplay="!visibleCapChartDialog" :interval="5000"
                     :arrow="comparisons.CAP.results.length > 1 ? 'hover' : 'never'"
                     @change="onChangeCapPage">
          <el-carousel-item v-for="(result, index) in comparisons.CAP.results" :key="index"
                            @click.native="visibleCapChartDialog=true">
            <div class="carousel-label"
                 :style="comparisons.CAP.results.length > 1 ? 'visibility: visible;' : 'visibility: hidden;'">
              {{result.name}}
            </div>
            <cap-chart v-if="Math.abs((index - currentCapPage + 1) % comparisons.CAP.results.length - 1) <= 1"
                       :capComparison="comparisons.CAP"
                       :yName="yName"
                       :categoryId="categoryId"
                       :initialColumnIndex="index"
                       size="mini"></cap-chart>
          </el-carousel-item>
        </el-carousel>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleCapChartDialog" custom-class="compare-dialog dialog-size-large" title="CAP曲線"
                   :append-to-body="true" :visible="visibleCapChartDialog" @close="visibleCapChartDialog=false" top="0"
                   :modal="false">
          <cap-chart :capComparison="comparisons.CAP" :yName="yName" :categoryId="categoryId"
                     :initialColumnIndex="currentCapPage"></cap-chart>
        </el-dialog>
      </el-card>

      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-mer-compare"
               @click.native="visibleMerCompareChartDialog=true"
               v-if="comparisons.MERCompare && comparisons.MERCompare.results">
        <div class="evaluations-chart-name">誤差の分布</div>
        <el-carousel v-if="comparisons.MERCompare && comparisons.MERCompare.results"
                     indicator-position="none"
                     trigger="click"
                     class="carousel-container"
                     :autoplay="!visibleMerCompareChartDialog" :interval="5000"
                     :arrow="comparisons.MERCompare.results.length > 1 ? 'hover' : 'never'"
                     @change="onChangeMerComparePage">
          <el-carousel-item v-for="(result, index) in comparisons.MERCompare.results" :key="index"
                            @click.native="visibleMerCompareChartDialog=true">
            <div class="carousel-label"
                 :style="comparisons.MERCompare.results.length > 1 ? 'visibility: visible;' : 'visibility: hidden;'">
              {{result.name}}
            </div>
            <mer-compare-chart
                    v-if="Math.abs((index - currentMerComparePage + 1) % comparisons.MERCompare.results.length - 1) <= 1"
                    :merCompareComparison="comparisons.MERCompare"
                    :yName="yName"
                    :categoryId="categoryId"
                    :initialColumnIndex="index"
                    size="mini"></mer-compare-chart>
          </el-carousel-item>
        </el-carousel>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleMerCompareChartDialog" custom-class="compare-dialog dialog-size-large" title="誤差の分布"
                   :append-to-body="true" :visible="visibleMerCompareChartDialog"
                   @close="visibleMerCompareChartDialog=false" top="0" :modal="false">
          <mer-compare-chart :merCompareComparison="comparisons.MERCompare" :yName="yName"
                             :categoryId="categoryId"></mer-compare-chart>
        </el-dialog>
      </el-card>

      <!-- time series -->
      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-trend"
               @click.native="visibleTrendChartDialog=true" v-if="comparisons.Trend && comparisons.Trend.results">
        <div class="evaluations-chart-name">トレンド</div>
        <trend-chart :trendComparison="comparisons.Trend" size="mini"></trend-chart>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleTrendChartDialog"
                   custom-class="compare-dialog dialog-size-large"
                   title="トレンド"
                   :append-to-body="true"
                   :visible="visibleTrendChartDialog"
                   @close="visibleTrendChartDialog=false"
                   top="0"
                   :modal="false">
          <trend-chart :trendComparison="comparisons.Trend"></trend-chart>
        </el-dialog>
      </el-card>

      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-yearly"
               @click.native="visibleYearlyChartDialog=true" v-if="comparisons.Yearly && comparisons.Yearly.results">
        <div class="evaluations-chart-name">1年間の周期性</div>
        <yearly-chart :yearlyComparison="comparisons.Yearly" size="mini"></yearly-chart>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleYearlyChartDialog"
                   custom-class="compare-dialog dialog-size-large"
                   title="1年間の周期性"
                   :append-to-body="true"
                   :visible="visibleYearlyChartDialog"
                   @close="visibleYearlyChartDialog=false"
                   top="0"
                   :modal="false">
          <yearly-chart :yearlyComparison="comparisons.Yearly"></yearly-chart>
        </el-dialog>
      </el-card>

      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-weekly"
               @click.native="visibleWeeklyChartDialog=true" v-if="comparisons.Weekly && comparisons.Weekly.results">
        <div class="evaluations-chart-name">1週間の周期性</div>
        <weekly-chart :weeklyComparison="comparisons.Weekly" size="mini"></weekly-chart>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleWeeklyChartDialog"
                   custom-class="compare-dialog dialog-size-large"
                   title="1週間の周期性"
                   :append-to-body="true"
                   :visible="visibleWeeklyChartDialog"
                   @close="visibleWeeklyChartDialog=false"
                   top="0"
                   :modal="false">
          <weekly-chart :weeklyComparison="comparisons.Weekly"></weekly-chart>
        </el-dialog>
      </el-card>

      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-daily"
               @click.native="visibleDailyChartDialog=true" v-if="comparisons.Daily && comparisons.Daily.results">
        <div class="evaluations-chart-name">1日の周期性</div>
        <daily-chart :dailyComparison="comparisons.Daily" size="mini"></daily-chart>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleDailyChartDialog"
                   custom-class="compare-dialog dialog-size-large"
                   title="1日の周期性"
                   :append-to-body="true"
                   :visible="visibleDailyChartDialog"
                   @close="visibleDailyChartDialog=false"
                   top="0"
                   :modal="false">
          <daily-chart :dailyComparison="comparisons.Daily"></daily-chart>
        </el-dialog>
      </el-card>

      <!-- unsupervised -->
      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-cluster-target"
               @click.native="visibleClusterTargetDialog=true" v-if="comparisons.ClusterTarget && comparisons.ClusterTarget.results">
        <div class="evaluations-chart-name">クラスタ毎のデータ数</div>
        <cluster-target-chart :clusterTargetComparison="comparisons.ClusterTarget" :yName="yName" size="mini"></cluster-target-chart>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleClusterTargetDialog"
                   custom-class="compare-dialog dialog-size-large"
                   title="クラスタ毎のデータ数"
                   :append-to-body="true"
                   :visible="visibleClusterTargetDialog"
                   @close="visibleClusterTargetDialog=false"
                   top="0"
                   :modal="false">
          <cluster-target-chart :clusterTargetComparison="comparisons.ClusterTarget" :yName="yName"></cluster-target-chart>
        </el-dialog>
      </el-card>

      <el-card shadow="hover" class="evaluation-chart-card evaluation-chart-cluster-distribution"
               @click.native="visibleClusterDistDialog=true" v-if="comparisons.ClusterDistribution && comparisons.ClusterDistribution.results">
        <div class="evaluations-chart-name">クラスタ毎のデータ分布</div>
        <cluster-distribution-chart :clusterDistributionComparison="comparisons.ClusterDistribution" :yName="yName" size="mini"></cluster-distribution-chart>
        <i class="el-icon-zoom-in zoom"></i>
        <el-dialog v-if="visibleClusterDistDialog"
                   custom-class="compare-dialog dialog-size-large"
                   title="クラスタ毎のデータ分布"
                   :append-to-body="true"
                   :visible="visibleClusterDistDialog"
                   @close="visibleClusterDistDialog=false"
                   top="0"
                   :modal="false">
          <cluster-distribution-chart :clusterDistributionComparison="comparisons.ClusterDistribution" :yName="yName"></cluster-distribution-chart>
        </el-dialog>
      </el-card>
    </div>
  </div>
</template>

<script>
import {EVALUATION_TITLE_TIP} from '../../defines/model/evaluation'
import CompareChartCmp from '../chart/compare.vue'
import LiftCompareChartCmp from '../chart/lift-compare.vue'
import CapChartCmp from '../chart/cap.vue'
import MerCompareChartCmp from '../chart/mer-compare.vue'
import TrendChartCmp from '../chart/trend.vue'
import DailyChartCmp from '../chart/daily.vue'
import WeeklyChartCmp from '../chart/weekly.vue'
import YearlyChartCmp from '../chart/yearly.vue'
import ClusterTargetChart from '../chart/cluster-target.vue'
import ClusterDistributionCmp from '../chart/cluster-distribution.vue'
import TextDistributionCmp from '../table/text-distribution.vue'

export default {
  name: 'EvaluationsCmp',
  components: {
    'compare-chart': CompareChartCmp,
    'lift-compare-chart': LiftCompareChartCmp,
    'cap-chart': CapChartCmp,
    'mer-compare-chart': MerCompareChartCmp,
    'trend-chart': TrendChartCmp,
    'daily-chart': DailyChartCmp,
    'weekly-chart': WeeklyChartCmp,
    'yearly-chart': YearlyChartCmp,
    'cluster-target-chart': ClusterTargetChart,
    'cluster-distribution-chart': ClusterDistributionCmp,
    'text-distribution': TextDistributionCmp
  },
  props: {
    evaluations: {},
    comparisons: {},
    yName: '',
    categoryId: ''
  },
  computed: {
    evaluationTitleTip () {
      return EVALUATION_TITLE_TIP
    }
  },
  data () {
    return {
      visibleCompareChartDialog: false,
      visibleLiftCompareChartDialog: false,
      visibleCapChartDialog: false,
      visibleMerCompareChartDialog: false,
      visibleTrendChartDialog: false,
      visibleDailyChartDialog: false,
      visibleWeeklyChartDialog: false,
      visibleYearlyChartDialog: false,
      visibleClusterTargetDialog: false,
      visibleClusterDistDialog: false,
      currentComparePage: 0,
      currentLiftComparePage: 0,
      currentCapPage: 0,
      currentMerComparePage: 0
    }
  },
  methods: {
    onChangeComparePage (currentPage) {
      this.currentComparePage = currentPage
      this.$forceUpdate()
    },
    onChangeLiftComparePage (currentPage) {
      this.currentLiftComparePage = currentPage
      this.$forceUpdate()
    },
    onChangeCapPage (currentPage) {
      this.currentCapPage = currentPage
      this.$forceUpdate()
    },
    onChangeMerComparePage (currentPage) {
      this.currentMerComparePage = currentPage
      this.$forceUpdate()
    },
    evaluationLevel (evaluation) {
      if (evaluation.score >= 1.0) {
        return 'Too Good' // #26a69a
      } else if (evaluation.score >= 0.8) {
        return 'Good' // #4caf50
      } else if (evaluation.score >= 0.6) {
        return 'Middle' // #8bc34a
      } else if (evaluation.score >= 0.4) {
        return 'Weak' // #ffca28
      } else {
        return 'Bad' // #ff8a65
      }
    },
    evaluationLevelCls (evaluation) {
      if (evaluation.score >= 1.0) {
        return 'evaluation-level-too-good'
      } else if (evaluation.score >= 0.8) {
        return 'evaluation-level-good'
      } else if (evaluation.score >= 0.6) {
        return 'evaluation-level-middle'
      } else if (evaluation.score >= 0.4) {
        return 'evaluation-level-weak'
      } else {
        return 'evaluation-level-bad'
      }
    }
  }
}

</script>

<style scoped>
  .evaluations-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }

  .evaluation-card {
    width: 180px;
    height: 130px;
    border: 1px solid #c0d5ef;
    margin: 8px;
    text-align: center;
    position: relative;
  }

  .evaluation-card .evaluation-card-name {
    color: #6ba7ef;
    text-align: center;
  }

  .evaluation-card >>> .el-card__body {
    padding: 20px 0;
  }

  .evaluation-card .evaluation-card-level {
    font-weight: bold;
  }

  .evaluation-card .evaluation-card-level.evaluation-level-too-good {
    color: #26a69a;
  }

  .evaluation-card .evaluation-card-level.evaluation-level-good {
    color: #4caf50;
  }

  .evaluation-card .evaluation-card-level.evaluation-level-middle {
    color: #8bc34a;
  }

  .evaluation-card .evaluation-card-level.evaluation-level-weak {
    color: #ffca28;
  }

  .evaluation-card .evaluation-card-level.evaluation-level-bad {
    color: #ff8a65;
  }

  .evaluation-card .evaluation-card-tip {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.1rem;
    color: #6ba7ef;
  }

  .evaluation-card .evaluation-card-value {
    font-size: 0.9rem;
    color: #394445;
  }

  .evaluations-chart-container,
  .evaluations-table-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }

  .evaluation-chart-card {
    width: 474px;
    height: 260px;
    border: 1px solid #c0d5ef;
    margin: 8px;
  }

  .evaluation-chart-card >>> .el-card__body {
    padding: 0;
    height: inherit;
  }

  .evaluation-chart-card .evaluations-chart-name {
    color: #6ba7ef;
    font-size: 0.95rem;
    padding-top: 6px;
    padding-left: 16px;
  }

  .evaluation-chart-card.evaluation-chart-trend >>> .el-card__body .chart-container,
  .evaluation-chart-card.evaluation-chart-daily >>> .el-card__body .chart-container,
  .evaluation-chart-card.evaluation-chart-weekly >>> .el-card__body .chart-container,
  .evaluation-chart-card.evaluation-chart-yearly >>> .el-card__body .chart-container,
  .evaluation-chart-card.evaluation-chart-cluster-target >>> .el-card__body .chart-container,
  .evaluation-chart-card.evaluation-chart-cluster-distribution >>> .el-card__body .chart-container,
  .evaluation-chart-card.evaluation-chart-text-evaluation-chart-cluster-distribution >>> .el-card__body .chart-container {
    margin-top: 24px;
  }

  .carousel-container,
  .carousel-container >>> .el-carousel__container {
    padding: 0;
    height: 100%;
  }

  .carousel-label {
    padding: 12px 0 4px;
    text-align: center;
  }

  .evaluation-chart-card .carousel-label {
    padding: 0;
  }

  .evaluation-chart-card >>> .el-card__body {
    position: relative;
  }

  .evaluation-chart-card >>> .el-card__body > i.zoom {
    position: absolute;
    top: 6px;
    right: 6px;
    color: #6ba7ef;
    font-size: 1.3rem;
  }

  .evaluation-table-card {
    width: 964px;
    border: 1px solid #c0d5ef;
    margin: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/model/evaluations.vue